<!-- Ручка ресайза. Панель прибита к правому краю, тянем за левую грань. -->
<div class="panel-resizer" (pointerdown)="startResize($event)" aria-hidden="true"></div>

<!-- Мобильный грабер: поднимает и опускает лист-шит. Пока агент ждёт
     решения, шит опускается сам, чтобы было видно подсвеченное поле. -->
<button
  type="button"
  class="panel-grabber"
  [attr.aria-label]="sheetToggleLabel"
  [attr.aria-expanded]="sheet() === 'full'"
  (click)="toggleSheet()">
  <span class="panel-grabber-bar"></span>
</button>

<div class="panel-header">
  <span class="panel-title">
    <i class="pi pi-sparkles"></i>
    <span i18n="@@assistant.title">Agent</span>
  </span>

  <p-selectButton
    class="panel-mode"
    [options]="modeOptions"
    optionLabel="label"
    optionValue="value"
    [allowEmpty]="false"
    [ngModel]="ui.mode()"
    (ngModelChange)="setMode($event)"
    i18n-pTooltip="@@assistant.mode.hint"
    pTooltip="Ask me — every change waits for your approval. Auto — the agent applies changes itself, you can undo them."
    tooltipPosition="bottom">
    <ng-template #item let-option>
      <i [class]="option.icon"></i>
      <span class="mode-label">{{ option.label }}</span>
    </ng-template>
  </p-selectButton>

  <p-button
    icon="pi pi-plus"
    [text]="true"
    [rounded]="true"
    size="small"
    i18n-pTooltip="@@assistant.newChat"
    pTooltip="New chat"
    tooltipPosition="bottom"
    [disabled]="!assistant.messages().length"
    (click)="newChat()"
    i18n-ariaLabel="@@assistant.newChat"
    ariaLabel="New chat">
  </p-button>
  <p-button
    icon="pi pi-history"
    [text]="true"
    [rounded]="true"
    size="small"
    [class.panel-history-active]="showHistory()"
    i18n-pTooltip="@@assistant.history"
    pTooltip="Chat history"
    tooltipPosition="bottom"
    (click)="toggleHistory()"
    i18n-ariaLabel="@@assistant.history"
    ariaLabel="Chat history">
  </p-button>
  <p-button
    icon="pi pi-times"
    [text]="true"
    [rounded]="true"
    size="small"
    (click)="close()"
    i18n-ariaLabel="@@assistant.close"
    ariaLabel="Close the agent panel">
  </p-button>
</div>

@if (assistant.plan().length) {
  <ol class="panel-plan">
    @for (step of assistant.plan(); track $index) {
      <li class="plan-step" [class.done]="step.status === 'done'"
          [class.active]="step.status === 'in_progress'"
          [class.skipped]="step.status === 'skipped'">
        @switch (step.status) {
          @case ('done') { <i class="pi pi-check-circle"></i> }
          @case ('in_progress') { <i class="pi pi-spin pi-spinner"></i> }
          @case ('skipped') { <i class="pi pi-minus-circle"></i> }
          @default { <i class="pi pi-circle"></i> }
        }
        <span>{{ step.title }}</span>
      </li>
    }
  </ol>
}

@if (showHistory()) {
  <div class="panel-history">
    <div class="history-head">
      <span i18n="@@assistant.history.title">Chat history</span>
      <p-button
        icon="pi pi-times"
        [text]="true"
        [rounded]="true"
        size="small"
        (click)="toggleHistory()"
        i18n-ariaLabel="@@common.close"
        ariaLabel="Close">
      </p-button>
    </div>

    @for (chat of historyItems(); track chat.id) {
      <button
        type="button"
        class="history-item"
        [class.current]="chat.active"
        (click)="openConversation(chat.id)">
        <span class="history-item-text">
          <span class="history-item-title">{{ chat.title }}</span>
          <span class="history-item-when">{{ when(chat.updatedAt) }}</span>
        </span>
        <i
          class="pi pi-trash history-item-remove"
          (click)="removeConversation(chat.id, $event)"
          i18n-title="@@common.delete"
          title="Delete"></i>
      </button>
    } @empty {
      <p class="history-empty" i18n="@@assistant.history.empty">
        No past chats yet — this is where they will be.
      </p>
    }

    @if (historyItems().length) {
      <button type="button" class="history-forget" (click)="askClearHistory()">
        <i class="pi pi-trash"></i>
        <span i18n="@@assistant.history.forgetAll">Forget all chats</span>
      </button>
    }

  </div>
}

<div class="panel-body" [class.hidden]="showHistory()" #scrollViewport>
  @if (assistant.error(); as err) {
    <div class="panel-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ err }}</span>
    </div>
  } @else if (!assistant.ready()) {
    <div class="panel-loading">
      <p-progressSpinner styleClass="!w-8 !h-8"></p-progressSpinner>
      <span i18n="@@assistant.connecting">Connecting…</span>
    </div>
  } @else {
    @if (!assistant.messages().length) {
      <div class="panel-empty">
        <i class="pi pi-sparkles"></i>
        <p i18n="@@assistant.empty.title">Ask the agent to do something in the app</p>
        <p class="panel-empty-hint" i18n="@@assistant.empty.hint">
          It reads your data, walks the interface with you and asks before every change.
        </p>
        <div class="panel-suggestions">
          @for (s of suggestions; track $index) {
            <button type="button" class="suggestion" (click)="useSuggestion(s)">{{ s }}</button>
          }
        </div>
      </div>
    }

    @for (msg of assistant.messages(); track $index) {
      @switch (msg.role) {
        @case ('user') {
          @if (isAutoContinue(msg)) {
            <div class="msg msg-system">
              <i class="pi pi-forward"></i>
              <span i18n="@@assistant.autoContinue">The agent continued on its own</span>
            </div>
          } @else {
            <div class="msg msg-user">
              <div class="msg-bubble">{{ contentToString(msg.content) }}</div>
            </div>
          }
        }
        @case ('assistant') {
          <div class="msg msg-assistant">
            @if (msg.content) {
              <div class="msg-bubble msg-bubble-md" [innerHTML]="renderMarkdown(msg.content)"></div>
            }
            @for (call of msg.toolCalls; track call.toolCallId) {
              @let view = toolCallView(call);
              @let expanded = isExpanded(call.toolCallId);
              <div class="tool-card" [class.pending]="view.running" [class.failed]="view.failed">
                <button
                  type="button"
                  class="tool-card-head"
                  [attr.aria-expanded]="expanded"
                  (click)="toggleCall(call.toolCallId)">
                  @if (view.running) {
                    <i class="pi pi-spin pi-spinner"></i>
                  } @else if (view.failed) {
                    <i class="pi pi-times-circle"></i>
                  } @else {
                    <i [class]="view.icon"></i>
                  }
                  <span class="tool-card-label">{{ view.label }}</span>
                  @if (view.argSummary) {
                    <span class="tool-card-args">{{ view.argSummary }}</span>
                  }
                  <i class="pi tool-card-chevron" [class.pi-chevron-down]="!expanded"
                     [class.pi-chevron-up]="expanded"></i>
                </button>

                @if (expanded) {
                  @let body = toolCallBody(call);
                  <div class="tool-card-body">
                    <div class="tool-card-section">
                      <span class="tool-card-section-title" i18n="@@assistant.tool.arguments">Arguments</span>
                      <pre>{{ body.args }}</pre>
                    </div>
                    @if (view.running) {
                      <div class="tool-card-section">
                        <span class="tool-card-section-title" i18n="@@assistant.tool.running">Still running…</span>
                      </div>
                    } @else {
                      <div class="tool-card-section">
                        <span class="tool-card-section-title">
                          @if (body.failed) {
                            <ng-container i18n="@@assistant.tool.error">Error</ng-container>
                          } @else {
                            <ng-container i18n="@@assistant.tool.response">Response</ng-container>
                          }
                        </span>
                        <pre [class.error]="body.failed">{{ body.result || '—' }}</pre>
                      </div>
                    }
                    @if (body.truncated) {
                      <p class="tool-card-note" i18n="@@assistant.tool.truncated">
                        Shown in part — the full value went to the model.
                      </p>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        @case ('error') {
          <div class="msg msg-error">
            <i class="pi pi-times-circle"></i>
            <span>{{ contentToString(msg.content) }}</span>
          </div>
        }
      }
    }

    @if (busy()) {
      <div class="msg msg-assistant">
        <div class="msg-bubble msg-bubble-streaming">
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </div>
      </div>
    }
  }
</div>

@if (pending().length) {
  <div class="panel-pending">
    @for (proposal of pending(); track proposal.id) {
      <app-assistant-proposal-card
        [proposal]="proposal"
        [showLocate]="true"
        [compact]="compactCards()">
      </app-assistant-proposal-card>
    }
  </div>
}

<div class="panel-footer">
  <div class="panel-input-row">
    <textarea
      #input
      pTextarea
      [autoResize]="true"
      rows="3"
      [disabled]="!assistant.ready()"
      [ngModel]="inputText()"
      (ngModelChange)="inputText.set($event)"
      (keydown)="onInputKeydown($event)"
      i18n-placeholder="@@assistant.placeholder"
      placeholder="Ask the agent…"
      class="panel-input">
    </textarea>
    @if (busy()) {
      <p-button
        icon="pi pi-stop"
        severity="danger"
        [rounded]="true"
        size="small"
        i18n-pTooltip="@@assistant.stop"
        pTooltip="Stop"
        (click)="stop()"
        i18n-ariaLabel="@@assistant.stop"
        ariaLabel="Stop">
      </p-button>
    } @else {
      <p-button
        icon="pi pi-send"
        [rounded]="true"
        size="small"
        [disabled]="!canSend()"
        (click)="send()"
        i18n-ariaLabel="@@assistant.send"
        ariaLabel="Send">
      </p-button>
    }
  </div>

  <!-- Агент меняет настоящие сущности, и ошибается он молча и уверенно.
       Строка стоит под полем ввода, а не в шапке: её читают в тот момент,
       когда решают, отправлять ли следующее поручение. -->
  <p class="panel-disclaimer" i18n="@@assistant.disclaimer">
    The agent can be wrong — check what it changed before you rely on it.
  </p>
</div>

<app-delete-confirmation
  [(visible)]="showClearDialog"
  [title]="clearDialogTitle"
  [subtitle]="clearDialogSubtitle"
  (confirm)="onClearConfirm()">
</app-delete-confirmation>
